import Vue from 'vue';
import store from './store/index';
import App from './App.vue';
import router from './router/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import ClassicEditor from './assets/js/ckeditor/ckeditor5-build-inline';
import pdfComponents from './utils/html2pdf';
import ScoreBox from './components/common/score-box';
import TopicEditBox from './components/common/edit-box';
import IntegerInput from './components/common/integer-input';
import MyUEditor from './components/common/ueditor';
import './utils/savePageData';
import './assets/css/common.scss';
import UserApi from "@/services/user";
import { setToken } from './utils/auth';
// import jquery from 'jquery'
// Vue.prototype.$JQ = jquery;
Vue.use(ScoreBox);
Vue.use(MyUEditor);
Vue.use(TopicEditBox);
Vue.use(IntegerInput);
Vue.use(ElementUI);
Vue.use(pdfComponents);
Vue.config.productionTip = false; //阻止你显示显示生产模式的消息
ElementUI.Dialog.props.closeOnClickModal.default = false;
// import CKEditor from './assets/js/ckeditor/ckeditor5-vue';
// Vue.use(CKEditor);

// Vue.prototype.$ckEditor = ClassicEditor;
router.beforeEach((to, from, next) => {
  // 可以在路由元信息指定哪些页面需要登录权限
  const token = window.localStorage.getItem('token');
  if(to.query.token) {
    setToken(to.query.token);
    next();
  } else {
    if (token && token.length) {
      next();
    } else {
      // 如果本地没有token 再调用下 userinfo接口 因为这个接口是站点互通的 不需要传参
      if (to.path.indexOf('/login') > -1) {
        next();
      } else {
        UserApi.UserInfo({}).then(res => {
          if(res.status == 200) {
            next();
          } else {
            next(`/login?redirect=${router.currentRoute.fullPath}`);
          }
        });
      }
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
